import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import Loader from '../components/common/Loader';

const MainLayout: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const location = useLocation();
  const [loading, setLoading] = useState(true);

  // Simulate page loading
  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => {
      setLoading(false);
      
      // After loading completes, scroll to hash if present
      if (location.hash) {
        // Wait for content to be fully rendered
        setTimeout(() => {
          const element = document.querySelector(location.hash);
          if (element) {
            // Get header height
            const header = document.querySelector('header');
            const headerHeight = header ? header.offsetHeight : 120;
            
            // Get element position
            const elementTop = element.getBoundingClientRect().top + window.pageYOffset;
            const offsetPosition = elementTop - headerHeight - 20;
            
            window.scrollTo({
              top: Math.max(0, offsetPosition),
              behavior: 'smooth'
            });
          }
        }, 100);
      }
    }, 800);
    
    return () => clearTimeout(timer);
  }, [location.pathname, location.hash]);

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          <Header />
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              width: '100%',
              minHeight: 'calc(100vh - 180px)',
            }}
          >
            <Outlet />
          </Box>
          <Footer />
        </>
      )}
    </>
  );
};

export default MainLayout; 